// We're filtering the `wasRedirected` state
// from the location so we don't perpetuate
// it, preventing circular navigation
export function stripRedirectFromLocation(location) {
	return {
		...location,
		state: {
			...location.state,
			wasRedirected: undefined,
		},
	};
}
